// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__-L+ZJ","total":"MasterSaleDetails_total__2Fdbn","edit":"MasterSaleDetails_edit__0Xogf","cancel":"MasterSaleDetails_cancel__as2TY"};